import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';

import PurchaseMethodsTabControlContainer from 'payment-calculator-v25/components/PaymentCalculatorDetails/components/PurchaseMethodsTabControl/PurchaseMethodsTabControlContainer.jsx';

import 'payment-calculator-v25/components/PaymentCalculatorDetails/PaymentCalculatorDetails.scss';

const PaymentCalculatorDetails = (props) => {
    return (
        <div className="showroom-calculator-new">
            <PurchaseMethodsTabControlContainer
                cashPurchaseSelected={props.cashPurchaseSelected}
                config={props.config}
                displayCreditRate={props.displayCreditRate}
            />
            <div className="calculator-done sr-paymentCalculator-Panelbackground">
                {
                    // TODO: #Will be activated later
                    // <button onClick={props.closePanel} className="sr-link">
                    //     { LocaleService.t('PAYMENT_CALCULATOR_V25.CANCELTITLE') }
                    // </button>
                }
                <button onClick={props.closePanel} className="sr-button-1 is-small">
                    {LocaleService.t('PAYMENT_CALCULATOR_V25.DONETITLE')}
                </button>
            </div>
        </div>
    );
};

PaymentCalculatorDetails.defaultProps = {
    displayCreditRate: false,
};
PaymentCalculatorDetails.propTypes = {
    cashPurchaseSelected: PropTypes.bool.isRequired,
    closePanel: PropTypes.func.isRequired,
    displayCreditRate: PropTypes.bool,
};

PaymentCalculatorDetails.displayName = 'PaymentCalculatorDetails';

export default PaymentCalculatorDetails;
